import React from 'react';

interface CardProps {
    children: React.ReactNode;
    className?: string;
    glassy?: boolean;
    padding?: 'none' | 'sm' | 'md' | 'lg';
    shadow?: 'sm' | 'md' | 'lg' | 'xl';
}

const Card: React.FC<CardProps> = ({
    children,
    className = '',
    glassy = false,
    padding = 'md',
    shadow = 'md'
}) => {
    const baseClasses = 'rounded-xl border transition-all duration-200';

    const glassyClasses = glassy
        ? 'bg-white/10 backdrop-blur-md border-white/20 shadow-xl'
        : 'bg-white border-gray-200';

    const paddingClasses = {
        none: 'p-0',
        sm: 'p-4',
        md: 'p-6',
        lg: 'p-8'
    };

    const shadowClasses = {
        sm: 'shadow-sm',
        md: 'shadow-md',
        lg: 'shadow-lg',
        xl: 'shadow-xl'
    };

    return (
        <div className={`${baseClasses} ${glassyClasses} ${paddingClasses[padding]} ${shadowClasses[shadow]} ${className}`}>
            {children}
        </div>
    );
};

export default Card;
